import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import RemoteAccessLogin from './RemoteAccessLoginBase';

export default withCombinedRouteParams(RemoteAccessLogin);
